import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-231" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-bold leading-[1.1] tracking-tight text-foreground sm:text-5xl sm:leading-[1.05]" data-id="element-232" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-233" data-mp="n097th74qt1s">
        <span className="h-1 w-10 rounded-full bg-primary" data-id="element-234" data-mp="i76f1ba6fnmn" />
        <span className="h-1 w-3 rounded-full bg-cta" data-id="element-235" data-mp="d8lm7wx98688" />
      </span>
    </div>;
}